export enum EExamGroupsType {
  CONTEST = 'CONTEST',
  CONTEST_OPPOSITION = 'CONTEST_OPPOSITION',
  OPPOSITION = 'OPPOSITION',
  ORDINARY = 'ORDINARY',
  EXTRAORDINARY = 'EXTRAORDINARY',
  JOB_BOARD = 'JOB_BOARD'
}

export const EXAM_TYPES = Object.values(EExamGroupsType);

export enum EExamGroupStatus {
  PENDING_DATE = 'PENDING_DATE',
  OPEN_PERIOD = 'OPEN_PERIOD',
  CLOSED_PERIOD = 'CLOSED_PERIOD',
  PROVISIONAL_LIST = 'PROVISIONAL_LIST',
  DEFINITIVE_LIST = 'DEFINITIVE_LIST',
  ANNOUNCED_DATE = 'ANNOUNCED_DATE',
  EXAM_IN_PROGRESS = 'EXAM_IN_PROGRESS',
  COMPETITION_PHASE = 'COMPETITION_PHASE',
  COMPLETED_PHASE = 'COMPLETED_PHASE',
  NOTES_PUBLISHED = 'NOTES_PUBLISHED'
}

export const EXAM_GROUP_IN_PROGRESS_STATES: EExamGroupStatus[] = [
    EExamGroupStatus.EXAM_IN_PROGRESS,
    EExamGroupStatus.COMPETITION_PHASE,
    EExamGroupStatus.PROVISIONAL_LIST
  ];

export const EXAM_GROUP_CLOSED_STATES: EExamGroupStatus[] = [EExamGroupStatus.CLOSED_PERIOD];

export const EXAM_GROUP_SUCCESS_STATES: EExamGroupStatus[] = [
    EExamGroupStatus.OPEN_PERIOD,
    EExamGroupStatus.DEFINITIVE_LIST,
    EExamGroupStatus.ANNOUNCED_DATE,
    EExamGroupStatus.NOTES_PUBLISHED,
    EExamGroupStatus.COMPLETED_PHASE
  ];
export const EXAM_GROUP_PENDING_STATES: EExamGroupStatus[] = [
    EExamGroupStatus.PENDING_DATE,
  ];

export const EXAM_GROUP_STATUS = Object.values(EExamGroupStatus);

export enum EExamGroupLinkType {
  OFFICIAL_BULLETIN_LINK = 'OFFICIAL_BULLETIN_LINK',
  REGISTRATION_GUIDE_LINK = 'REGISTRATION_GUIDE_LINK',
  REGISTRATION_LINK = 'REGISTRATION_LINK',
  APPLICATION_TRACKING_LINK = 'APPLICATION_TRACKING_LINK',
  PROVISIONAL_LIST_LINK = 'PROVISIONAL_LIST_LINK',
  DEFINITIVE_LIST_LINK = 'DEFINITIVE_LIST_LINK',
  OTHER_LINK = 'OTHER_LINK'
}

export const EXAM_GROUP_LINK_TYPE = Object.values(EExamGroupLinkType);
